import mapFunction from './mapResources';

export default mapFunction('material_search_results', {
    isFetching: false,
    items: [] 
});